/* eslint-disable */
export const provinces = [
  {
    id: '01',
    name: 'TP Hà Nội',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '02',
    'Mô tả': 'Ma4069: 101',
    'Hiệu lực': '1',
    STT: 1,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '101'
  },
  {
    id: '02',
    name: 'Hà Giang',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '01',
    'Mô tả': 'Ma4069: 201',
    'Hiệu lực': '1',
    STT: 2,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '201'
  },
  {
    id: '04',
    name: 'Cao Bằng',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '01',
    'Mô tả': 'Ma4069: 203',
    'Hiệu lực': '1',
    STT: 3,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '203'
  },
  {
    id: '06',
    name: 'Bắc Kạn',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '01',
    'Mô tả': 'Ma4069: 207',
    'Hiệu lực': '1',
    STT: 4,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '207'
  },
  {
    id: '08',
    name: 'Tuyên Quang',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '01',
    'Mô tả': 'Ma4069: 211',
    'Hiệu lực': '1',
    STT: 5,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '211'
  },
  {
    id: '10',
    name: 'Lào Cai',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '01',
    'Mô tả': 'Ma4069: 205',
    'Hiệu lực': '1',
    STT: 6,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '205'
  },
  {
    id: '11',
    name: 'Điện Biên',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '01',
    'Mô tả': 'Ma4069: TT: 11',
    'Hiệu lực': '1',
    STT: 7,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '11'
  },
  {
    id: '12',
    name: 'Lai Châu',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '01',
    'Mô tả': 'Ma4069: 301',
    'Hiệu lực': '1',
    STT: 8,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '301'
  },
  {
    id: '14',
    name: 'Sơn La',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '01',
    'Mô tả': 'Ma4069: 303',
    'Hiệu lực': '1',
    STT: 9,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '303'
  },
  {
    id: '15',
    name: 'Yên Bái',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '01',
    'Mô tả': 'Ma4069: 213',
    'Hiệu lực': '1',
    STT: 10,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '213'
  },
  {
    id: '17',
    name: 'Hoà Bình',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '01',
    'Mô tả': 'Ma4069: 305',
    'Hiệu lực': '1',
    STT: 11,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '305'
  },
  {
    id: '19',
    name: 'Thái Nguyên',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '01',
    'Mô tả': 'Ma4069: 215',
    'Hiệu lực': '1',
    STT: 12,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '215'
  },
  {
    id: '20',
    name: 'Lạng Sơn',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '01',
    'Mô tả': 'Ma4069: 209',
    'Hiệu lực': '1',
    STT: 13,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '209'
  },
  {
    id: '22',
    name: 'Quảng Ninh',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '02',
    'Mô tả': 'Ma4069: 225',
    'Hiệu lực': '1',
    STT: 14,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '225'
  },
  {
    id: '24',
    name: 'Bắc Giang',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '01',
    'Mô tả': 'Ma4069: 221',
    'Hiệu lực': '1',
    STT: 15,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '221'
  },
  {
    id: '25',
    name: 'Phú Thọ',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '01',
    'Mô tả': 'Ma4069: 217',
    'Hiệu lực': '1',
    STT: 16,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '217'
  },
  {
    id: '26',
    name: 'Vĩnh Phúc',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '02',
    'Mô tả': 'Ma4069: 104',
    'Hiệu lực': '1',
    STT: 17,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '104'
  },
  {
    id: '27',
    name: 'Bắc Ninh',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '02',
    'Mô tả': 'Ma4069: 223',
    'Hiệu lực': '1',
    STT: 18,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '223'
  },
  {
    id: '30',
    name: 'Hải Dương',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '02',
    'Mô tả': 'Ma4069: 107',
    'Hiệu lực': '1',
    STT: 19,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '107'
  },
  {
    id: '31',
    name: 'TP Hải Phòng',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '02',
    'Mô tả': 'Ma4069: 103',
    'Hiệu lực': '1',
    STT: 20,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '103'
  },
  {
    id: '33',
    name: 'Hưng Yên',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '02',
    'Mô tả': 'Ma4069: 109',
    'Hiệu lực': '1',
    STT: 21,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '109'
  },
  {
    id: '34',
    name: 'Thái Bình',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '02',
    'Mô tả': 'Ma4069: 115',
    'Hiệu lực': '1',
    STT: 22,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '115'
  },
  {
    id: '35',
    name: 'Hà Nam',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '02',
    'Mô tả': 'Ma4069: 111',
    'Hiệu lực': '1',
    STT: 23,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '111'
  },
  {
    id: '36',
    name: 'Nam Định',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '02',
    'Mô tả': 'Ma4069: 113',
    'Hiệu lực': '1',
    STT: 24,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '113'
  },
  {
    id: '37',
    name: 'Ninh Bình',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '02',
    'Mô tả': 'Ma4069: 117',
    'Hiệu lực': '1',
    STT: 25,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '117'
  },
  {
    id: '38',
    name: 'Thanh Hóa',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '03',
    'Mô tả': 'Ma4069: 401',
    'Hiệu lực': '1',
    STT: 26,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '401'
  },
  {
    id: '40',
    name: 'Nghệ An',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '03',
    'Mô tả': 'Ma4069: 403',
    'Hiệu lực': '1',
    STT: 27,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '403'
  },
  {
    id: '42',
    name: 'Hà Tĩnh',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '03',
    'Mô tả': 'Ma4069: 405',
    'Hiệu lực': '1',
    STT: 28,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '405'
  },
  {
    id: '44',
    name: 'Quảng Bình',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '03',
    'Mô tả': 'Ma4069: 407',
    'Hiệu lực': '1',
    STT: 29,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '407'
  },
  {
    id: '45',
    name: 'Quảng Trị',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '03',
    'Mô tả': 'Ma4069: 409',
    'Hiệu lực': '1',
    STT: 30,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '409'
  },
  {
    id: '46',
    name: 'Thừa Thiên Huế',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '03',
    'Mô tả': 'Ma4069: 411',
    'Hiệu lực': '1',
    STT: 31,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '411'
  },
  {
    id: '48',
    name: 'TP Đà Nẵng',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '03',
    'Mô tả': 'Ma4069: 501',
    'Hiệu lực': '1',
    STT: 32,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '501'
  },
  {
    id: '49',
    name: 'Quảng Nam',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '03',
    'Mô tả': 'Ma4069: 503',
    'Hiệu lực': '1',
    STT: 33,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '503'
  },
  {
    id: '51',
    name: 'Quảng Ngãi',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '03',
    'Mô tả': 'Ma4069: 505',
    'Hiệu lực': '1',
    STT: 34,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '505'
  },
  {
    id: '52',
    name: 'Bình Định',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '03',
    'Mô tả': 'Ma4069: 507',
    'Hiệu lực': '1',
    STT: 35,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '507'
  },
  {
    id: '54',
    name: 'Phú Yên',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '03',
    'Mô tả': 'Ma4069: 509',
    'Hiệu lực': '1',
    STT: 36,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '509'
  },
  {
    id: '56',
    name: 'Khánh Hòa',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '03',
    'Mô tả': 'Ma4069: 511',
    'Hiệu lực': '1',
    STT: 37,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '511'
  },
  {
    id: '58',
    name: 'Ninh Thuận',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '03',
    'Mô tả': 'Ma4069: 705',
    'Hiệu lực': '1',
    STT: 38,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '705'
  },
  {
    id: '60',
    name: 'Bình Thuận',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '03',
    'Mô tả': 'Ma4069: 715',
    'Hiệu lực': '1',
    STT: 39,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '715'
  },
  {
    id: '62',
    name: 'Kon Tum',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '04',
    'Mô tả': 'Ma4069: 601',
    'Hiệu lực': '1',
    STT: 40,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '601'
  },
  {
    id: '64',
    name: 'Gia Lai',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '04',
    'Mô tả': 'Ma4069: 603',
    'Hiệu lực': '1',
    STT: 41,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '603'
  },
  {
    id: '66',
    name: 'Đắk Lắk',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '04',
    'Mô tả': 'Ma4069: 605',
    'Hiệu lực': '1',
    STT: 42,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '605'
  },
  {
    id: '67',
    name: 'Đắk Nông',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '04',
    'Mô tả': 'Ma4069: TT: 67',
    'Hiệu lực': '1',
    STT: 43,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '67'
  },
  {
    id: '68',
    name: 'Lâm Đồng',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '04',
    'Mô tả': 'Ma4069: 607',
    'Hiệu lực': '1',
    STT: 44,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '607'
  },
  {
    id: '70',
    name: 'Bình Phước',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '05',
    'Mô tả': 'Ma4069: 707',
    'Hiệu lực': '1',
    STT: 45,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '707'
  },
  {
    id: '72',
    name: 'Tây Ninh',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '05',
    'Mô tả': 'Ma4069: 709',
    'Hiệu lực': '1',
    STT: 46,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '709'
  },
  {
    id: '74',
    name: 'Bình Dương',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '05',
    'Mô tả': 'Ma4069: 711',
    'Hiệu lực': '1',
    STT: 47,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '711'
  },
  {
    id: '75',
    name: 'Đồng Nai',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '05',
    'Mô tả': 'Ma4069: 713',
    'Hiệu lực': '1',
    STT: 48,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '713'
  },
  {
    id: '77',
    name: 'Bà Rịa - Vũng Tàu',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '05',
    'Mô tả': 'Ma4069: 717',
    'Hiệu lực': '1',
    STT: 49,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '717'
  },
  {
    id: '79',
    name: 'TP Hồ Chí Minh',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '05',
    'Mô tả': 'Ma4069: 701',
    'Hiệu lực': '1',
    STT: 50,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '701'
  },
  {
    id: '80',
    name: 'Long An',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '06',
    'Mô tả': 'Ma4069: 801',
    'Hiệu lực': '1',
    STT: 51,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '801'
  },
  {
    id: '82',
    name: 'Tiền Giang',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '06',
    'Mô tả': 'Ma4069: 807',
    'Hiệu lực': '1',
    STT: 52,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '807'
  },
  {
    id: '83',
    name: 'Bến Tre',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '06',
    'Mô tả': 'Ma4069: 811',
    'Hiệu lực': '1',
    STT: 53,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '811'
  },
  {
    id: '84',
    name: 'Trà Vinh',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '06',
    'Mô tả': 'Ma4069: 817',
    'Hiệu lực': '1',
    STT: 54,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '817'
  },
  {
    id: '86',
    name: 'Vĩnh Long',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '06',
    'Mô tả': 'Ma4069: 809',
    'Hiệu lực': '1',
    STT: 55,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '809'
  },
  {
    id: '87',
    name: 'Đồng Tháp',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '06',
    'Mô tả': 'Ma4069: 803',
    'Hiệu lực': '1',
    STT: 56,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '803'
  },
  {
    id: '89',
    name: 'An Giang',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '06',
    'Mô tả': 'Ma4069: 805',
    'Hiệu lực': '1',
    STT: 57,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '805'
  },
  {
    id: '91',
    name: 'Kiên Giang',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '06',
    'Mô tả': 'Ma4069: 813',
    'Hiệu lực': '1',
    STT: 58,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '813'
  },
  {
    id: '92',
    name: 'TP Cần Thơ',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '06',
    'Mô tả': 'Ma4069: 815',
    'Hiệu lực': '1',
    STT: 59,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '815'
  },
  {
    id: '93',
    name: 'Hậu Giang',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '06',
    'Mô tả': 'Ma4069: TT: 93',
    'Hiệu lực': '1',
    STT: 60,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '93'
  },
  {
    id: '94',
    name: 'Sóc Trăng',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '06',
    'Mô tả': 'Ma4069: 819',
    'Hiệu lực': '1',
    STT: 61,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '819'
  },
  {
    id: '95',
    name: 'Bạc Liêu',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '06',
    'Mô tả': 'Ma4069: 821',
    'Hiệu lực': '1',
    STT: 62,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '821'
  },
  {
    id: '96',
    name: 'Cà Mau',
    'Mã Quốc gia': 'VN',
    'Mã vùng': '06',
    'Mô tả': 'Ma4069: 823',
    'Hiệu lực': '1',
    STT: 63,
    'Từ ngày': '01/01/2015',
    'Mã BYT': '823'
  }
  // {
  //   id: '97',
  //   name: 'Bộ Quốc Phòng',
  //   'Mã Quốc gia': 'VN',
  //   'Mã vùng': '00',
  //   'Hiệu lực': '1',
  //   STT: 64,
  //   'Từ ngày': '01/01/2015'
  // },
  // {
  //   id: '98',
  //   name: 'Công an nhân dân',
  //   'Mã Quốc gia': 'VN',
  //   'Mã vùng': '00',
  //   'Hiệu lực': '1',
  //   STT: 65,
  //   'Từ ngày': '01/01/2015'
  // },
  // {
  //   id: '30s',
  //   name: 'Tỉnh Hải Dương',
  //   'Mã Quốc gia': 'VN',
  //   'Mã vùng': '02',
  //   'Hiệu lực': '1',
  //   STT: 99,
  //   'Từ ngày': '29/09/2023',
  //   'Mã BYT': '107'
  // },
  // {
  //   id: '311',
  //   name: 'Thành Phố Hải Phòng',
  //   'Mã Quốc gia': 'VN',
  //   'Mã vùng': '02',
  //   'Hiệu lực': '1',
  //   STT: 999,
  //   'Từ ngày': '18/10/2023',
  //   'Mã BYT': '103'
  // }
]
